export default {
  series: 1,
  data: 'Category;Series 1\nA;40'
};
